import styled from 'styled-components';

import { Button, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	position: relative;
	text-align: center;

	padding: 52px 0 48px;

	${minWidth('desktop')} {
		padding-top: 62px;
	}

	${minWidth('desktopLarge')} {
		padding-top: 200px;
	}
`;

export const ImageWrapper = styled.div`
	align-items: flex-end;
	aspect-ratio: 2160/1081;
	display: flex;
	margin: 0 auto;
	max-width: 1440px;
	margin-bottom: 176px;
	position: relative;
	text-align: center;
	width: 100%;
`;

export const Background = styled(FullscreenBackground)`
	z-index: -1;
`;

export const ImageGridWrapper = styled.div`
	bottom: -140px;
	position: relative;
	width: 100%;
`;

export const Photo = styled.div`
	aspect-ratio: 1.82;
	display: block;
	margin: 0 auto 36px;
	position: relative;
	width: 90%;
`;

export const Heading = styled.h1`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 36px;
	position: relative;
	text-align: center;

	${minWidth('tablet')} {
		margin-bottom: 48px;
	}

	&:after {
		background-image: url('/_n/images/schools/flourish-squiggle.webp');
		background-repeat: no-repeat;
		background-size: contain;
		content: '';
		display: block;
		position: absolute;
		left: 50%;
		bottom: -20%;
		transform: translateX(-50%);
		width: 124px;
		height: 20px;

		${minWidth('tablet')} {
			bottom: -35%;
			left: 50%;
			height: 32px;
			transform: translateX(0);
			width: 192px;
		}
	}
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 1fr;
	margin-bottom: 36px;

	${minWidth('tablet')} {
		grid-template-columns: 1fr 1fr 1fr;
		margin-bottom: 72px;
	}
`;

export const Blurb = styled.h5`
	${fontWeight(FontWeights.Regular)};
	text-align: left;
`;

export const CtaButton = styled(Button)`
	margin: 0 auto;
`;
